module.exports = __webpack_public_path__ + "img/low_spec_exp.4d1e33bb.png";